export default {
  init() {
    // JavaScript to be fired on the design quote request form page
    $('.percentage-field input').on('keyup', function(){
      var percentage = 0;
      $('.percentage-field input').each(function(){
        var intVal = parseInt($(this).val());
        if(isNaN(intVal)) {
          intVal = 0;
        }
        percentage = percentage + intVal;
      });

      if(percentage == 100){
        $('.percentage').addClass('full');
      }else{
        $('.percentage').removeClass('full');
      }
      $('.percentage').html('Total Percentage: <span>'+percentage.toString()+'%</span>');
    });

    $('.frm_description').each(function(){
      $(this).siblings('.frm_primary_label').append('<span class="contact-info"></span>');
      $(this).attr('title',$(this).html());
      $(this).appendTo($(this).siblings('.frm_primary_label').find('.contact-info'));
      $(this).closest('.contact-info').attr('title',$(this).html());
      $(this).closest('.contact-info').tooltip();
      $(this).html('');
    });

    //populate hidden fields from form 1
    $('.design-request-form-two .frm_final_submit').click(function(e){
      e.preventDefault();
      e.stopPropagation();
      $(this).prop('disabled',true);
      var contactFormData = $('#form_design-request-contact-form').serializeArray();
      var contactFormDataJson = {};

      $.map(contactFormData, function(n){
        contactFormDataJson[n['name']] = n['value'];
      });
      var filePostId = contactFormDataJson['item_meta[88]'];

      //fetch file url
      $.ajax({
        type: 'post',
        dataType: 'json',
        url: myAjax.ajaxurl,
        data: {action: 'get_file_url', post_id: filePostId},
        success: function(response) {
          if(response.type == 'success'){
            if(response.file_url !== false){
              $('#form_design-request-form-bottom').find('#field_ydxer').val(response.file_url);

              //populate hidden fields
              $('#form_design-request-form-bottom').find('#field_gmawb').val(contactFormDataJson['item_meta[81]']);
              $('#form_design-request-form-bottom').find('#field_4hxco').val(contactFormDataJson['item_meta[82]']);
              $('#form_design-request-form-bottom').find('#field_1g2l').val(contactFormDataJson['item_meta[83]']);
              $('#form_design-request-form-bottom').find('#field_2p85m').val(contactFormDataJson['item_meta[84]']);
              $('#form_design-request-form-bottom').find('#field_3903h').val(contactFormDataJson['item_meta[85]']);
              $('#form_design-request-form-bottom').find('#field_zsw0s').val(contactFormDataJson['item_meta[86]']);
              $('#form_design-request-form-bottom').find('#field_2lf3q').val(contactFormDataJson['item_meta[87]']);
              $('#form_design-request-form-bottom').find('#field_9edtr').val(contactFormDataJson['item_meta[89][]']);

              $('#form_design-request-form-bottom').submit();
            }
          }
        },
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/designQuoteRequestForm.js